import Quries from "./CountryContainer";

export default Quries;
